import { render } from "./VendorView.vue?vue&type=template&id=34e0af5d&scoped=true"
import script from "./VendorView.vue?vue&type=script&lang=js"
export * from "./VendorView.vue?vue&type=script&lang=js"

import "./VendorView.vue?vue&type=style&index=0&id=34e0af5d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e0af5d"]])

export default __exports__